export default {
	title: "",
	subtitle: "Example - Credit Card Transaction",
  path: "transaction_cc",
	paragraph: "This example covers a transaction of BRL 2500.50 using the credit card for a FacilitaPay account to be converted to USD and sent to the partner's USD bank account. Note that it provides the credit card details on the fly. If you want to register(tokenize) the credit card prior to the transaction, please refer to the credit card registration endpoint above.",
	request: {
		method: "POST", 
		endpoint: "/transactions",
		payload: {
			"transaction": {
				"currency": "BRL",
				"exchange_currency": "USD",
				"value": "2500.50",
				"from_credit_card": {
					"card_number": "4761739001010036",
					"card_expiration_date": "12/2022",
					"card_security_code": "123",
					"card_brand": "Visa",
					"fullname": "Jose Silva",
				},
				"to_bank_account_id": "766eadfc-f020-4d2a-bed3-c9a95623ed24",
				"subject_id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21"
			}
		},
			responses: {
				"data": {
					"value": "2500.50",
					"to_bank_account": {
						"routing_number": "29483242",
						"owner_name": null,
						"owner_document_number": null,
						"owner_company": {
							"social_name": "Dagny Taggart",
							"id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21",
							"document_type": "passport",
							"document_number": "J83579487346"
						},
						"intermediary_bank_account": null,
						"id": "766eadfc-f020-4d2a-bed3-c9a95623ed24",
						"iban": null,
						"currency": "USD",
						"branch_number": null,
						"branch_country": null,
						"bank": {
							"swift": "BDK9348309",
							"name": "Bank D'Anconia",
							"id": "77c1ef53-9376-4a96-9aa2-af038a3ba39d",
							"code": null
						},
						"account_type": "conta-corrente",
						"account_number": "0101100",
						"aba": null
				},
				"subject_is_receiver": true,
				"subject_id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21",
				"subject": {
					"updated_at": "2021-04-29T22:15:10.988964",
					"status": "approved",
					"social_name": "Dagny Taggart",
					"required_clearance_level": 1,
					"references": [],
					"phone_number": null,
					"net_monthly_average_income": "15000.00",
					"inserted_at": "2021-03-08T19:56:22.628081",
					"id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21",
					"fiscal_country": "Brasil",
					"email": null,
					"document_type": "passport",
					"document_number": "J83579487346",
					"clearance_level": 1,
					"birth_date": "1965-04-06",
					"address_street": "Sherman Ave",
					"address_state": "DC",
					"address_postal_code": "12394",
					"address_number": "2252",
					"address_country": "United States (US)",
					"address_complement": "Apt 101",
					"address_city": "Washington"
				},
				"status": "identified",
				"source_name": "Dagny Taggart",
				"source_document_type": "passport",
				"source_document_number": "J83579487346",
				"inserted_at": "2021-05-07T18:22:11.346220",
				"id": "8da57ca6-2f09-460c-b155-8358ed7657c9",
				"from_credit_card": {
					"status": "tokenized",
					"phone_number": "99123-2313",
					"phone_country_code": "55",
					"phone_area_code": "18",
					"inserted_at": "2021-05-07T18:22:11.345036",
					"id": "e5e6e87d-77e0-45c0-9fed-e2e2f36dffca",
					"document_type": "CPF",
					"document_number": "24189952087",
					"birthdate": "1990-12-03"
				},
				"from_bank_account": null,
				"for_exchange": true,
				"exchange_under_request": false,
				"exchange_currency": "USD",
				"estimated_value_until_exchange": false,
				"currency": "BRL",
				"cleared": true,
				"bank_transaction": null
			}
		}  
	},
	parameterPayload: [
		{
			name: "transaction",
			type: "object",
			required: true,
			description: "An object containing all the required values needed"
		},
		{
			name: "transaction.currency",
			type: "string",
			required: true,
			description: "Source currency for the transaction (ISO 4217 format)"
		},
		{
			name: "transaction.exchange_currency",
			type: "string",
			required: true,
			description: "Currency to be exchanged (ISO 4217 format)"
		},
		{
			name: "transaction.value",
			type: "string",
			required: true,
			description: "Value to be exchanged (in the source currency)"
		},
		{
			name: "transaction.from_credit_card_id",
			type: "string",
			required: false,
			description: "A registered (tokenized) credit card ID can also be provided instead of the whole credit card data",
			requiredFor: "When you don't send from_credit_card"
		},
		{
			name: "transaction.from_credit_card",
			type: "object",
			required: false,
			description: "An object, containing the following parameters:",
			requiredFor: "When you don't send from_credit_card_id"
		},
		{
			name: "transaction.from_credit_card.card_number",
			type: "string",
			required: false,
			description: "Credit card number. Valid credit card numbers would also work, but debit card numbers won't"
		},
		{
			name: "transaction.from_credit_card.card_expiration_date",
			type: "string",
			required: false,
			description: "Card expiration date (mm/yyyy)"
		},
		{
			name: "transaction.from_credit_card.card_security_code",
			type: "string",
			required: false,
			description: "3-digit card security code"
		},
		{
			name: "transaction.from_credit_card.card_brand",
			type: "string",
			required: false,
			description: "Brand of the credit card used in the transaction (e.g., Visa, MasterCard)"
		},
		{
			name: "transaction.from_credit_card.fullname",
			type: "string",
			required: false,
			description: "Full name of the credit card's owner"
		},
		{
			name: "transaction.from_credit_card.birthdate",
			type: "string",
			required: false,
			description: "Birthdate of the credit card's owner"
		},
		{
			name: "transaction.from_credit_card.document_type",
			type: "string",
			required: false,
			description: "A document for credit card's owner"
		},
		{
			name: "transaction.from_credit_card.document_number",
			type: "string",
			required: false,
			description: "A document number of the credit card's owner"
		},
		{
			name: "transaction.from_credit_card.phone_country_code",
			type: "string",
			required: false,
			description: "Country phones code (2 digits: BR +55; MX +52; COP +57; CL +52)"
		},
		{
			name: "transaction.from_credit_card.phone_area_code",
			type: "string",
			required: false,
			description: "Internal country area code"
		},
		{
			name: "transaction.from_credit_card.phone_number",
			type: "string",
			required: false,
			description: "Contact phone number linked to the credit card holder"
		},
		{
			name: "transaction.to_bank_account_id",
			type: "string",
			required: true,
			description: "ID of an USD bank account from the partner"
		},
		{
			name: "transaction.subject_id",
			type: "string",
			required: true,
			description: "ID of one of the partner's customer"
		}
	],
	footerNotes: "All transactions initiated in sandbox will be stored as 'Wired'. In the production environment they will be initially on 'Identified' status."
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionCreditCard.js